import * as Yup from "yup";
import { Regex } from "../../utils/constants/constants";
import { validationMessage } from "../../utils/validation";
import { Values } from "./LoginForm";

export const loginInitValues: Values = {
  Email: "",
  Password: "",
};

export const passwordRegEx =
  /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*_+=-?])(?=^.{8,100}$)/;

export const loginValidationSchema = Yup.object().shape({
  Email: Yup.string()
    .max(100, validationMessage.max(100))
    .required("To pole jest wymagane"),
  Password: Yup.string()
    .max(100, validationMessage.max(100))
    // .matches(passwordRegEx, validationMessage.weekPassword)
    .required("To pole jest wymagane"),
});

export const registerInitValues = {
  Email: "",
  FirstName: "",
  LastName: "",
  Position: "",
  PhoneNumber: "",
};

export const categoryValidationSchema = Yup.object().shape({
  Name: Yup.string().required(validationMessage.isRequired),
});

export const registerValidationSchema = Yup.object().shape({
  Email: Yup.string()
    .email(validationMessage.invalidEmail)
    .required(validationMessage.isRequired),
  FirstName: Yup.string().required(validationMessage.isRequired),
  LastName: Yup.string().required(validationMessage.isRequired),

  PhoneNumber: Yup.string()
    .required(validationMessage.isRequired)
    .max(15, validationMessage.max(15))
    .matches(Regex.phone, validationMessage.invalidPhone),
  Position: Yup.string().required(validationMessage.isRequired),
});

export const forgotPasswordInitValues = {
  email: "",
};

export const resetPasswordInitValues = {
  NewPassword: "",
  RepeatNewPassword: "",
};

export const forgotPasswordValidation = Yup.object().shape({
  email: Yup.string()
    .email(validationMessage.invalidEmail)
    .required(validationMessage.isRequired),
});

export const resetPasswordValidation = Yup.object().shape({
  NewPassword: Yup.string().required(validationMessage.isRequired),
  RepeatNewPassword: Yup.string().required(validationMessage.isRequired),
});
